/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React from "react";
import { useParams, useNavigate } from 'react-router-dom';

import { useAuth, useDispatcher } from "../../components/AuthProvider"



function ItemContainer(props) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const results = useAuth();
  let { id } = useParams();


  let items = results.simResults.simModel.items;
  let index = items.findIndex(a => a.baseID === parseInt(id));
  if (index === -1) {
    return null;
  }

  function findModelItem(id) { // TODO - move to model manager
    let item = results.currentModel.model.items.find( a => a.id === id);
    return item;
  }


  let simItem = results.simResults.simModel.items[index];
  let simModel = results.simResults.simModel;
  let modelItem = findModelItem(simItem.baseID);
  //let categories = results.simResults.simModel.summary;
  //let timespan = results.simResults.timeSpan;


  function onSubmit(action) {
    dispatch(action);
    navigate(-1);
  }


  function onCancel() {
    navigate(-1);
  }



  return (
    <div>
      {React.cloneElement(props.children, {simModel, simItem, modelItem, onSubmit, onCancel})}
    </div>
  );
}


export default ItemContainer;

